import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
} from '@angular/core';
import { NotificationType } from './notification-type.enum';

@Component({
  selector: 'conn-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  standalone: false,
})
export class NotificationComponent implements OnInit, OnChanges, OnDestroy {
  notificationTypesInTheUI = NotificationType;
  @Input() notificationType: NotificationType;
  @Input() toast: boolean;
  @Input() message: string;
  @Input() timeoutInMill: number;
  @Input() messageIsHTML = false;
  @Input() dismissOnClick = true;
  @Output() doneWithNotification: EventEmitter<boolean>;

  // holds the id of the timeout used to auto-dismiss the toast so it can be
  // cleared when the component is destroyed (prevents emits after destroy)
  private closeTimeoutId: number | null = null;

  /**
   * Notifications, A.K.A. toasts are little informational pop up messages to confirm the result of some
   * user interaction.  Some examples might be to inform the user that their changes were successfully saved
   * or that there was an issue when trying to save some data.  Include the <conn-notification> tag with the
   * the above inputs.
   */
  constructor() {
    this.doneWithNotification = new EventEmitter<boolean>();
  }

  ngOnInit() {
    if (!this.timeoutInMill) {
      this.timeoutInMill = 3000;
    }
  }

  ngOnChanges() {
    if (this.toast) {
      this.showResult();
    }
  }

  showResult() {
    if (this.toast) {
      // store the timeout id so we can clear it in ngOnDestroy and in close()
      this.closeTimeoutId = window.setTimeout(
        () => {
          if (this.toast) {
            this.close();
          }
          this.closeTimeoutId = null;
        },
        this.timeoutInMill as unknown as number,
      );
    }
  }

  close() {
    // clear any pending auto-close timeout to avoid emitting after destroy or
    // emitting twice
    if (this.closeTimeoutId) {
      clearTimeout(this.closeTimeoutId);
      this.closeTimeoutId = null;
    }
    this.toast = false;
    this.doneWithNotification.emit(this.toast);
  }

  ngOnDestroy(): void {
    if (this.closeTimeoutId) {
      clearTimeout(this.closeTimeoutId);
      this.closeTimeoutId = null;
    }
  }

  dismiss() {
    if (this.dismissOnClick) {
      this.close();
    }
  }
}
